import { render } from "./CustomAlertNote.vue?vue&type=template&id=1c8d2ac0&scoped=true&ts=true"
import script from "./CustomAlertNote.vue?vue&type=script&lang=ts"
export * from "./CustomAlertNote.vue?vue&type=script&lang=ts"

import "./CustomAlertNote.vue?vue&type=style&index=0&id=1c8d2ac0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8d2ac0"]])

export default __exports__